import React from 'react';
import ReactDOM from 'react-dom';

import 'normalize.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initDocTitleAndDesc } from './utils/util';
initDocTitleAndDesc();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// console.log('log env', process.env.REACT_APP_LOGROCKET_ENABLED);

// console.log('env', process.env.REACT_APP_BUILD_ENV);
